import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './Home';
import AddProblem from './AddProblem';
import Header from './Header';
import EditProblem from './EditProblem';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <Header />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/add-problem" element={<AddProblem />} />
          <Route path="/edit" element={<EditProblem />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
